export default __webpack_public_path__ + "static/media/homeOn.b4d66bba.svg";